import { MEMBERS_LOGO_URL } from "@/lib/api";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative px-5 pb-8 pt-8">
    <div className="mx-auto flex max-w-6xl items-center justify-start">
      <a
        data-testid="the-monde-mania-footer-link"
        href="https://themondemania.com/members"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-3 transition-transform hover:scale-105"
      >
        <img
          src={MEMBERS_LOGO_URL}
          alt="The Monde Mania"
          className="w-14 mix-blend-multiply sm:w-16"
          draggable="false"
        />
        <span className="font-tech text-[10px] uppercase tracking-[0.25em] text-white/90">
          Want to model more?
        </span>
      </a>
    </div>
  </footer>
);
